import { render, staticRenderFns } from "./savedTemplatesNavBar.vue?vue&type=template&id=8e01669e&scoped=true&"
import script from "./savedTemplatesNavBar.vue?vue&type=script&lang=js&"
export * from "./savedTemplatesNavBar.vue?vue&type=script&lang=js&"
import style0 from "./savedTemplatesNavBar.vue?vue&type=style&index=0&id=8e01669e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e01669e",
  null
  
)

export default component.exports